const isFacilitator = (u) => u.profile === 'Facilitator_c';
const isLearner = (u) => u.profile === 'Learner_c';
const isOwner = (r, u) => String(r.Owner?.Id ?? r.Owner) === String(u.Id);

export const select = (record, user) => {
  if (!user) return false;
  if (isFacilitator(user)) return true;
  if (isLearner(user)) return isOwner(record, user);
  return false;
};

export const insert = (record, user) => {
  if (!user) return false;
  if (isFacilitator(user)) return true;
  return isLearner(user);
};

export const update = (record, user) => {
  if (!user) return false;
  if (isFacilitator(user)) return true;
  if (isLearner(user)) return isOwner(record, user);
  return false;
};

export const remove = (record, user) => {
  if (!user) return false;
  return isFacilitator(user);
};
